/// <reference path="Utilities/_reference.ts" />
/// <reference path="../../../node_modules/@types/pickadate/index.d.ts" />

interface IFormData {
	[key: string]: string;
	fileUrl?: string;
}

module YVR.Forms {
	// Utilities
	import date = YVR.Utilities.Dates;
	import logger = YVR.Utilities.Logger;
	import mq = YVR.Utilities.MediaQueries;

	const Parsley = (window as any).Parsley;

	// CSS Classes
	const classes = {
		body: 'yvr-form__body',
		dateFields: 'yvr-form__input--date',
		errorList: 'yvr-form__server-error',
		form: 'yvr-form',
		messageActive: 'yvr-form__message--active',
		timeFields: 'yvr-form__input--time',
		success: 'yvr-form__success',
		submitButton: 'yvr-button--submit'
	};

	const curbsideClasses = {
		body: 'yvr-curbside-assistance',
		reservationNumber : 'reservation-number'
	}

	function main() {
		initCustomValidator();
		initDatePicker();

		eventBindings();
		//eventBindRecaptcha();

		initCurbsideAssistance();
	}


	/**
	 * Initialise custom Parsley validators
	 */
	function initCustomValidator() {
		console.log(Parsley);
		if (Parsley) {
			Parsley.addValidator('beforedatetime', {
				requirementType: 'string',
				validateString(value, requirement) {
					if (requirement && requirement.length) {
						let form = $(requirement).closest('.yvr-form');

						const startDate = form.find('.yvr-form__date--start:visible').val().split('/');
						const startTime = form.find('.yvr-form__time--start:visible').val().split(':');
						const startDateTime = new Date(startDate[2], startDate[1] - 1, startDate[0], startTime[0], startTime[1]);

						const endDate = form.find('.yvr-form__date--end:visible:visible').val().split('/');
						const endTime = form.find('.yvr-form__time--end:visible:visible').val().split(':');
						const endDateTime = new Date(endDate[2], endDate[1] - 1, endDate[0], endTime[0], endTime[1]);

						return startDateTime < endDateTime;
					}

					return true;
				}
			});

			Parsley.addValidator('beforenow', {
				requirementType: 'string',
				validateString(value, requirement) {
					if (requirement && requirement.length) {
						let form = $(requirement).closest('.yvr-form');

						const dateField = form.find('.yvr-form__input--date:visible');
						const timeField = form.find('.yvr-form__input--time:visible');

						const adate = dateField.val().split('/');
						const time = timeField.val().split(':');

						if (adate.length !== 3 || time.length !== 2) {
							return true;
						}

						const dateTime = new Date(adate[2], adate[1] - 1, adate[0], time[0], time[1]).getTime();

						return dateTime < (new Date).getTime();
					}

					return true;
				}
			});
		}
	}


	/**
	 * Initialise date picker plugin
	 */
	function initDatePicker() {
		$(`.${classes.dateFields}`).each((index, element) => {
			const input = $(element);

				

			const options: Pickadate.DateOptions = {
				format: date.CONSANTS.SHORT_DATE,
				klass: {
					day: 'picker__day notranslate'
				},
				onClose() {
					this.$node.parsley().validate();
				}
			};

			if (input.data('min-date-today')) {
				options.min = new Date();
			}

			if (input.data('max-date-today')) {
				options.max = new Date();
			}

			input.pickadate(options);

			// Disable readonly
			input.prop("readonly", false);

			// Update placeholder on focus
			input.on("focus", function (e) {
				$(e.target).attr("placeholder", "dd/mm/yyyy");
			});


			// Update / remove unneccessary aria attributes as per documents
			$('.picker__day').each(function () {
				$(this).attr("aria-label", $(this).attr("aria-label").split("/")[0]);
			});
			$('.picker__day--disabled').attr("aria-hidden", "true");
			$('.picker__table').removeAttr("aria-controls");
			$('.picker__nav--next').removeAttr("aria-controls");
			$('.picker__nav--prev').removeAttr("aria-controls");
			$('.picker__button--today').removeAttr("aria-controls");
			$('.picker__button--clear').removeAttr("aria-controls");
			$('.picker__weekday').each(function () {
				$(this).attr("aria-label", $(this).attr("title"));
			});
		});

		$(`.${classes.timeFields}`).each((index, element) => {
			const input = $(element);

			const options: Pickadate.TimeOptions = {
				format: 'HH:i',
				interval: 15,
				klass: {
					picker: 'picker picker--time notranslate'
				},
				onClose() {
					this.$node.parsley().validate();
				},
				onOpen: function () {	//set a delay so the dropdown for time actually displays
					let pickerbox = $('.picker__box');

					if (pickerbox != null && pickerbox.length > 1) {

						let timePickerbox = pickerbox[1];
						timePickerbox.style.position = 'static';
						setTimeout(
							function () {
								timePickerbox.style.position = 'relative';
							}
							, 25);
					}
				}
			};

			input.pickatime(options);
		});
	}


	/**
	 * Attach various events to form elements.
	 */
	function eventBindings(): void {
		console.log('form event bindings');
		$(`.${classes.submitButton}`).on('click', submitForm);

		$('.parking-alert').on("change", function () {
			var alert = $(this).find('yvr-form__error-item parsley-required');
			alert.focus();
			alert.attr('role', 'alert');
		});
		
	}

	//function eventBindRecaptcha(): void {
	//	console.log('bind recaptcha');
	//	if (window.grecaptcha) {
	//		grecaptcha.ready(function () {
	//			grecaptcha.execute('6Le5EWcaAAAAAFXxFpVbIpU2KmvB1eEC7aP6fFeU', { action: 'contactform' }).then(function (token) {
	//				if (token == null) {
	//					console.log("Token returned is null");
	//				} else {
	//					console.log("Adding token: " + token);
	//					$('<input>').attr({
	//						type: 'hidden',
	//						name: 'Token',
	//						value: token,
	//						id: 'recaptcha'
	//					}).prependTo('.yvr-form');
	//				}
	//			});
	//		});
	//	}
	//}


	/**
	 * Gather all data from a form and send it to a web service.
	 * @param {Object} e A jQuery event.
	 */
	function submitForm(e: JQueryEventObject): void {
		console.log('submit form');
		e.preventDefault();

		generateCaptcha();

		const form = $(this.form);

		form.find(`.${classes.errorList}`).removeClass(classes.messageActive);

		if (window['startrecaptcha']) {
			waitForElm('#recaptcha').then((elm) => {
				const valid = form.parsley().validate();

				if (valid) {
					const data = getFormData(form);
					submitFormData(form, data);
				}
			});
		} else {
			const valid = form.parsley().validate();

			if (valid) {
				const data = getFormData(form);
				submitFormData(form, data);
			}
		}
	}

	function waitForElm(selector) {
		return new Promise(resolve => {
			if (document.querySelector(selector)) {
				return resolve(document.querySelector(selector));
			}

			const observer = new MutationObserver(mutations => {
				if (document.querySelector(selector)) {
					resolve(document.querySelector(selector));
					observer.disconnect();
				}
			});

			observer.observe(document.body, {
				childList: true,
				subtree: true
			});
		});
	}

	function generateCaptcha() {
		let event = new CustomEvent('recaptchatoken');
		let $element = $("html");
		$element[0].dispatchEvent(event);
	}


	/**
	 * Loop through all form elements and create an object of data.
	 * @param {Object} form A jQuery element of the form.
	 */
	function getFormData(form: JQuery): IFormData {
		const data = {};

		const inputs = [
			'input[type=text]',
			'input[type=email]',
			'input[type=checkbox]:checked',
			'input[type=radio]:checked',
			'input[type=hidden]',
			'textarea',
			'select'
		];

		form.find(inputs.join(', ')).each(function () {
			if (this.name.length && $(this).attr('disabled') === undefined) {
				data[this.name] = this.value;
			}
		});

		return data;
	}


	/**
	 * Send form data to web service.
	 * @param {Object} form A jQuery object containing the current form.
	 * @param {Object} data The extracted form data.
	 */
	function submitFormData(form: JQuery, data: IFormData): JQueryPromise<any> {
		console.log('submit form data');
		const url = form.data('service-url');
		console.log('url: ' + url);
		console.log(data);
		return $.post({
			url,
			data,
			success(response) {
				if (response.success || response.value) {
					logger.log('[forms][submitFormData] Successfully submitted the form.');
					console.log('[forms][submitFormData] Successfully submitted the form.');
					const offset = ['xs', 'sm'].includes(mq.state) ? $('.yvr-critical-message').outerHeight() : 0;

					form.find(`.${classes.body}`)
						.addClass(`${classes.body}--complete`)
						.animate({
							height: 0
						},
						400,
						'swing',
						() => {
							form.find(`.${classes.success}`).addClass(classes.messageActive);
						});

					$.scrollTo(form, {
						duration: 400,
						offset: {
							top: -1 * offset - 20
						}
					});

					checkFileDownload(response);
				} else if (response.message) {
					console.log('[forms][submitFormData] Not sucessfully.' + response.message);
					form.find(`.${classes.errorList}`).attr('role', 'alert');
					form.find(`.${classes.errorList}`).text(response.message);
					form.find(`.${classes.errorList}`).focus();
				}
			},
			error: function (xhr, textStatus, error) {
				console.log(xhr.statusText);
				console.log(textStatus);
				console.log(error);
				form.find(`.${classes.errorList}`).addClass(classes.messageActive).attr('role', 'alert');
				form.find(`.${classes.errorList}`).focus();
			}
		});
	}


	/**
	 * Redirect to a file if it exists.
	 * @param {Object} data
	 */
	function checkFileDownload(data: IFormData): void {
		if (data.fileUrl) {
			window.location.href = data.fileUrl;
		}
	}

	function initCurbsideAssistance() {
		let curbsideForm = $('.yvr-curbside-assistance');

		if (curbsideForm.length <= 0) {
			return;
		}

		let reservationNumberInput = curbsideForm.find('.reservation-number');

		if (reservationNumberInput.length < 1) {
			return;
		}

		let currentDate = new Date();
		let year = currentDate.getFullYear().toString();
		let month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
		let day = currentDate.getDate().toString().padStart(2, '0');
		let hours = currentDate.getHours().toString().padStart(2, '0');
		let minutes = currentDate.getMinutes().toString().padStart(2, '0');
		let seconds = currentDate.getSeconds().toString().padStart(2, '0');
		let milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
		let randomPart = Math.floor(Math.random() * 1000).toString().padStart(3, '0'); // Random 3-digit number
		let randomReservationNumber = year + month + day + hours + minutes + seconds + milliseconds + randomPart;

		reservationNumberInput.val(randomReservationNumber);

		console.log('reservation number: ');
		console.log(randomReservationNumber);
	}


	main();
}
